import shopManage from './shop_manage'
export default {
	shopManage
}



// WEBPACK FOOTER //
// ./src/store/mp/shops/index.js